import React from "react";
import MuiLinearProgress, { linearProgressClasses }  from "@mui/material/LinearProgress";
import { styled } from "@mui/material/styles";

const LinearProgress = ({ value, min=0, max=100, size=10, color=null, preLabel=null, postLabel=null, style={} }) => {

    const StyledLinearProgress = styled(MuiLinearProgress)(({ theme }) => ({
        height: size,
        borderRadius: size / 2,
        width: "100%",
        [`&.${linearProgressClasses.colorPrimary}`]: {
          backgroundColor: "var(--wnp-color-secondary-extralight)",
        },
        [`& .${linearProgressClasses.bar}`]: {
          borderRadius: size / 2,
          backgroundColor: color ? color : "var(--wnp-color-primary)",
        },
    }));

    const normalizedValueFromRange = value => {
        return ((value - min) * 100) / (max - min);
    }

    return (
        <div style={{ display: "flex", alignItems: "center", width: "100%", ...style }}>
            {preLabel}
            <StyledLinearProgress variant="determinate" value={normalizedValueFromRange(value)} />
            {postLabel}
        </div>
    )
}

export default LinearProgress;
